import { useSelector } from 'react-redux';
import useSubscriptions from 'services/general/subscriptionsList';
import { getConsultCreditsCount } from 'store/account';
import { Typography } from '@repo/ui';

export const ConsultPricing = () => {
  const consultCreditsCount = useSelector(getConsultCreditsCount);
  const { isAnyTinyPlus } = useSubscriptions();
  const isFullPrice = !isAnyTinyPlus;

  return consultCreditsCount > 0 ? (
    <div className='text-center'>
      <Typography variant='label'>{`You have ${consultCreditsCount} free review${
        consultCreditsCount === 1 ? '' : 's'
      } remaining.`}</Typography>
    </div>
  ) : (
    <div className='text-center'>
      <Typography variant='label'>Calls are </Typography>
      {!isFullPrice && (
        <Typography variant='label' className='line-through'>
          $100
        </Typography>
      )}
      <Typography variant='label'>
        {isFullPrice ? `$100` : ` $39`} per 20 minute call.
      </Typography>
    </div>
  );
};
